import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-modal-email',
  templateUrl: './modal-email.component.html',
  styleUrls: ['./modal-email.component.scss']
})
export class ModalEmailComponent implements OnInit {
  email = new UntypedFormControl('', [Validators.required, Validators.email]);

  constructor(public dialogRef: MatDialogRef<ModalEmailComponent>, @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
  }

  getErrorMessage() {
    if (this.email.hasError('required')) {
      return 'Ce champ est obligatoire';
    }

    return this.email.hasError('email') ? 'Email invalide' : '';
  }

  setEmail() {
    this.dialogRef.close(this.email.value)
  }

}
